import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { MessageCircle, Calendar } from "lucide-react";
import { getWhatsAppUrl } from "@/lib/constants";
import Breadcrumbs from "@/components/Breadcrumbs";
import CTABanner from "@/components/CTABanner";
import drPortrait from "@/assets/doctor/doctor-hero-clinic.jpg";
import teamLineup from "@/assets/team/team-group-2.jpg";
import teamGroup from "@/assets/team/team-group-1.jpg";

// team-group-2 is the 8-person standing lineup. Approximate horizontal face positions:
// 1 male (left) ~6%, woman blazer ~18%, woman blue ~30%, Dr. Khushboo (pink) ~45%,
// woman white coat ~58%, nurse blue ~70%, nurse pink ~82%, male white shirt ~95%
const doctors = [
  { name: "Dr. Khushboo Mutha", designation: "Founder & Lead Dentist", specialty: "Implantology & Prosthodontics", experience: "10+ Years", days: "Mon–Sat", image: drPortrait, position: "center 25%" },
  { name: "Consultant Orthodontist", designation: "Orthodontist", specialty: "Braces & Aligners", experience: "5+ Years", days: "Mon, Wed, Fri", image: teamLineup, position: "6% center" },
  { name: "Consultant Endodontist", designation: "Endodontist", specialty: "Root Canal Treatment", experience: "7+ Years", days: "Tue, Thu, Sat", image: teamLineup, position: "95% center" },
  { name: "Consultant Periodontist", designation: "Periodontist", specialty: "Gum Treatment", experience: "6+ Years", days: "Mon–Fri", image: teamGroup, position: "center 30%" },
];

const AssociateDoctors = () => (
  <div>
    <section className="bg-secondary py-12 md:py-16">
      <div className="container">
        <Breadcrumbs items={[{ label: "Our Doctors" }]} />
        <h1 className="font-heading text-3xl md:text-4xl font-bold text-secondary-foreground mb-3">Meet Our Dental Team</h1>
        <p className="text-secondary-foreground/80 max-w-2xl">
          Our team of experienced dental professionals is dedicated to providing you with the best care in Kalyan.
        </p>
      </div>
    </section>

    <section className="py-16">
      <div className="container">
        <div className="grid md:grid-cols-2 gap-6">
          {doctors.map((doc) => (
            <Card key={doc.name} className="overflow-hidden">
              <CardContent className="p-0">
                <div className="flex flex-col sm:flex-row">
                  <div className="sm:w-40 aspect-[4/3] sm:aspect-auto sm:h-auto shrink-0 bg-muted overflow-hidden">
                    <img src={doc.image} alt={doc.name} className="w-full h-full object-cover" style={{ objectPosition: doc.position }} width={320} height={400} loading="lazy" decoding="async" />
                  </div>
                  <div className="p-5 flex-1">
                    <h2 className="font-heading font-bold mb-1">{doc.name}</h2>
                    <p className="text-sm text-primary font-medium mb-2">{doc.designation}</p>
                    <div className="space-y-1 text-sm text-muted-foreground mb-4">
                      <p><strong>Specialty:</strong> {doc.specialty}</p>
                      <p><strong>Experience:</strong> {doc.experience}</p>
                      <p className="flex items-center gap-1"><Calendar className="h-3.5 w-3.5" /> {doc.days}</p>
                    </div>
                    <Button asChild size="sm">
                      <a href={getWhatsAppUrl(`Hi, I'd like to book with ${doc.name}.`)} target="_blank" rel="noopener noreferrer">
                        <MessageCircle className="h-4 w-4 mr-2" /> Book with {doc.designation}
                      </a>
                    </Button>
                  </div>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>

        <div className="text-center mt-12 p-8 bg-accent/50 rounded-2xl">
          <h3 className="font-heading text-lg font-semibold mb-2">Not Sure Which Doctor to See?</h3>
          <p className="text-sm text-muted-foreground mb-4">Chat with us and we'll guide you</p>
          <Button asChild>
            <a href={getWhatsAppUrl("Hi, I need help choosing the right doctor.")} target="_blank" rel="noopener noreferrer">
              <MessageCircle className="h-5 w-5 mr-2" /> Ask on WhatsApp
            </a>
          </Button>
        </div>
      </div>
    </section>

    <CTABanner />
  </div>
);

export default AssociateDoctors;
